import { LeadAPIRequest } from "src/utils/leadAPIClient";
import { CruiseSuiteFormProps } from "./DefaultSubscribeForm";
import { LeadFormData } from "./types";
import { toUTCDate } from "../../utils/date";
import { isPresent } from "src/utils/checks";

function booleanToInt(value: boolean | 1 | 0 | undefined): 1 | 0 | undefined {
  if (!isPresent(value)) return undefined;
  return value ? 1 : 0;
}

export function formDataToLeadAPIRequest(
  formData: LeadFormData
): LeadAPIRequest {
  const {
    IsNotAgent,
    WorkingWithAgent,
    SailDate,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    RequestType,
    Price,
    ...otherFormData
  } = formData;

  const parsedPrice = parsePrice(Price);

  return {
    ...otherFormData,
    ...(isPresent(SailDate) && { SailDate: toUTCDate(SailDate) }),
    ...(isPresent(IsNotAgent) && { IsAgent: booleanToInt(!IsNotAgent) }),
    ...(isPresent(WorkingWithAgent) && {
      WorkingWithAgent: booleanToInt(WorkingWithAgent)
    }),
    ...(isPresent(parsedPrice) && { Price: parsedPrice }),
    RequestType: RequestType,
    RequestDate: new Date()
  } as LeadAPIRequest;
}

export function cruiseSuiteInfoToLeadFormData(
  cruiseSuiteInfo: CruiseSuiteFormProps | undefined
): Partial<LeadFormData> {
  if (!cruiseSuiteInfo) return {};
  return {
    VoyageCod: cruiseSuiteInfo.voyageCode,
    Voyage: cruiseSuiteInfo.voyageName,
    Ship: cruiseSuiteInfo.shipName,
    SailDate: cruiseSuiteInfo.departureDate,
    Price: parsePrice(cruiseSuiteInfo.price),
    SuiteVariation: cruiseSuiteInfo.suiteVariation
    //SuiteCategory: ""
    //ArrivalPort: "",
    //DeparturePort:
  };
}

function parsePrice(price: number | string | undefined): number | undefined {
  if (typeof price === "string") {
    if (price == "") return undefined;
    return Number(price);
  }

  return price;
}
